import { useState, useRef, useEffect, useCallback } from "react";

/**
 * Hook for filter menu UI state: visibility toggle, outside-click closing,
 * phase list for project-phase filter, and the container ref.
 *
 * Replaces Zustand tab UI state for: showFilterMenu, filterPhaseList,
 * setShowFilterMenu, setFilterPhaseList, and the useEffect/useRef boilerplate.
 */
export const useFilterMenu = () => {
  const [showFilterMenu, setShowFilterMenu] = useState(false);
  const [filterPhaseList, setFilterPhaseList] = useState([]);
  const filterMenuRef = useRef(null);

  const toggleFilterMenu = useCallback(() => {
    setShowFilterMenu((prev) => !prev);
  }, []);

  // Close filter menu when clicking outside (identical logic currently in all 5 tabs)
  useEffect(() => {
    if (!showFilterMenu) return;
    const handleOutsideClick = (event) => {
      // Don't close if clicking on date picker portal or calendar
      const isDatePickerClick =
        event.target.closest(".react-datepicker-popper") ||
        event.target.closest(".react-datepicker") ||
        event.target.closest("#date-picker-portal");

      if (
        filterMenuRef.current &&
        !filterMenuRef.current.contains(event.target) &&
        !isDatePickerClick
      ) {
        setShowFilterMenu(false);
      }
    };
    document.addEventListener("mousedown", handleOutsideClick, true);
    document.addEventListener("touchstart", handleOutsideClick, true);
    return () => {
      document.removeEventListener("mousedown", handleOutsideClick, true);
      document.removeEventListener("touchstart", handleOutsideClick, true);
    };
  }, [showFilterMenu]);

  return {
    showFilterMenu,
    setShowFilterMenu,
    toggleFilterMenu,
    filterPhaseList,
    setFilterPhaseList,
    filterMenuRef,
  };
};
